import {
  addActionBarItem,
  registerFormInputComponent,
  addNavMenuItem,
  addNavMenuSection,
  registerBulkAction,
  registerCustomDetailComponent,
  Permission,
  registerPageTab,
  PageLocationId,
} from "@bb-vendure/admin-ui/core";
import { marker as _ } from "@biesbjerg/ngx-translate-extract-marker";
import BulkThreshold from "./components/bulk-threshold/threshold.component";
import { take } from "rxjs";
import { deleteProductsBulkAction } from "./components/product-list/product-list-bulk-actions";
import {
  assignProductsToChannelBulkAction,
  removeProductsFromChannelBulkAction,
  assignFacetValuesToProductsBulkAction,
  duplicateProductsBulkAction,
} from "@bb-vendure/admin-ui/catalog";
import { ProductListComponent } from "./components/product-list/product-list.component";
import { VersionCardComponent } from "./components/version-card/version-card.component";
import { OrderListComponent } from "./components/order-list/order-list.component";

export default [
  registerCustomDetailComponent({
    locationId: "global-settings-detail",
    component: VersionCardComponent,
  }),
  registerFormInputComponent("bulk-threshold", BulkThreshold),

  registerBulkAction(deleteProductsBulkAction),
  // registerBulkAction(assignProductsToChannelBulkAction),
  // registerBulkAction(assignFacetValuesToProductsBulkAction),
  // registerBulkAction(removeProductsFromChannelBulkAction),
  registerBulkAction(duplicateProductsBulkAction),

  addNavMenuSection({
    id: "rule-section",
    label: "nav.rule",
    items: [],
  }),

  addNavMenuSection(
    {
      id: "ticket-section",
      label: "nav.ticket",
      items: [],
    },
    "rule-section"
  ),

  addNavMenuSection(
    {
      id: "event-section",
      label: "nav.event",
      items: [
        {
          id: "event-planning",
          label: "nav.event-planning",
          routerLink: ["/extensions/event-planning"],
          icon: "form",
          requiresPermission: (userPermissions) => {
            return userPermissions.includes("ReadEventPlanning");
          },
        },
        {
          id: "event",
          label: "nav.events",
          routerLink: ["/extensions/event"],
          icon: "event",
          requiresPermission: (userPermissions) => {
            return userPermissions.includes("ReadEvent");
          },
        },
      ],
      requiresPermission: (userPermission) => {
        return true;
      },
    },
    "marketing"
  ),

  addNavMenuSection(
    {
      id: "shipping-section",
      label: "nav.shipping",
      items: [],
    },
    "event-section"
  ),

  addNavMenuSection(
    {
      id: "package-review",
      label: "nav.package",
      items: [
        {
          id: "package-review",
          label: "nav.package-review",
          icon: "bundle",
          routerLink: ["/extensions/package-reviews"],
        },
      ],
      requiresPermission: (userPermissions) => {
        return userPermissions.includes("ReadPackageReview");
      },
    },
    "shipping-section"
  ),
  // addNavMenuSection(
  //   {
  //     id: "need-to-ship-section",
  //     label: "Need to ship",
  //     items: [],
  //   },
  //   "package-section"
  // ),

  addNavMenuSection(
    {
      id: "inbound-section",
      label: "nav.inbound",
      items: [
        {
          id: "inbound-request",
          label: "nav.inbound-request",
          icon: "bundle",
          routerLink: ["/extensions/inbound-request"],
          requiresPermission: (userPermissions) => {
            return userPermissions.includes("ReadInboundingApproval");
          },
        },
        {
          id: "inbound-complete",
          label: "nav.inbound-complete",
          icon: "bundle",
          routerLink: ["/extensions/inbound-complete"],
          requiresPermission: (userPermissions) => {
            return userPermissions.includes("ReadInboundingApproval");
          },
        },
      ],
    },
    "package-review"
  ),

  addNavMenuSection(
    {
      id: "purchase-request",
      label: "nav.purchase-request",
      items: [],
    },
    "inbound-section"
  ),

  registerPageTab({
    location: "custom-product-list" as PageLocationId,
    tab: "nav.all-products",
    route: "/catalog/products",
    //tabIcon: "star",
    component: ProductListComponent,
  }),

  registerPageTab({
    location: "custom-product-list" as PageLocationId,
    tab: "nav.upcoming",
    route: "../upcoming",
    //tabIcon: "star",
    component: ProductListComponent,
  }),

  registerPageTab({
    location: "custom-product-list" as PageLocationId,
    tab: "nav.pre-order",
    route: "../pre-order",
    //tabIcon: "star",
    component: ProductListComponent,
  }),

  registerPageTab({
    location: "custom-product-list" as PageLocationId,
    tab: "nav.currently-selling",
    route: "../currently-selling",
    //tabIcon: "star",
    component: ProductListComponent,
  }),

  registerPageTab({
    location: "custom-product-list" as PageLocationId,
    tab: "nav.stock-on-hand",
    route: "../stock-on-hand",
    //tabIcon: "star",
    component: ProductListComponent,
  }),

  registerPageTab({
    location: "custom-product-list" as PageLocationId,
    tab: "nav.sold-out",
    route: "../sold-out",
    //tabIcon: "star",
    component: ProductListComponent,
  }),

  registerPageTab({
    location: "custom-product-list" as PageLocationId,
    tab: "nav.events",
    route: "../events",
    //tabIcon: "star",
    component: ProductListComponent,
  }),

  registerPageTab({
    location: "custom-product-list" as PageLocationId,
    tab: "nav.unshipped",
    route: "../unshipped",
    //tabIcon: "truck",
    component: ProductListComponent,
  }),

  // Order 탭 등록
  registerPageTab({
    location: "order-list" as PageLocationId,
    tab: "common.total",
    route: "/orders",
    component: OrderListComponent,
  }),

  registerPageTab({
    location: "order-list" as PageLocationId,
    tab: "order.payment-settled",
    route: "/orders/payment-settled",
    component: OrderListComponent,
  }),

  registerPageTab({
    location: "order-list" as PageLocationId,
    tab: "order.payment-pending",
    route: "/orders/payment-pending",
    component: OrderListComponent,
  }),

  registerPageTab({
    location: "order-list" as PageLocationId,
    tab: "order.cancelled",
    route: "/orders/cancelled",
    component: OrderListComponent,
  }),

  registerPageTab({
    location: "order-list" as PageLocationId,
    tab: "order.payment-error",
    route: "/orders/payment-error",
    component: OrderListComponent,
  }),

  addNavMenuSection(
    {
      id: "products-section",
      label: "nav.product",
      items: [
        {
          id: "products",
          label: "nav.product-v-sku",
          routerLink: ["/catalog", "products"],
          requiresPermission: (userPermissions) =>
            userPermissions.includes(Permission.ReadCatalog) ||
            userPermissions.includes(Permission.ReadProduct),
        },
        {
          id: "wh-product",
          label: "nav.product-p-sku",
          routerLink: ["/extensions", "wh-product"],
          icon: "bundle",
        },
        {
          id: "free-gifts",
          label: "nav.free-gift",
          routerLink: ["/extensions", "free-gift"],
          icon: "briefcase",
          requiresPermission: (userPermissions) =>
            userPermissions.includes(Permission.ReadCatalog) ||
            userPermissions.includes(Permission.ReadProduct),
        },
        {
          id: "product-type",
          label: "nav.product-type",
          routerLink: ["/extensions/product-type"],
          icon: "file-group",
          requiresPermission: (userPermissions) =>
            userPermissions.includes("ReadProductType"),
        },
        {
          id: "artist",
          label: "nav.artists",
          icon: "star",
          routerLink: ["/extensions/artists"],
          requiresPermission: (userPermissions) =>
            userPermissions.includes("ReadArtist"),
        },


      ],
    },
    "catalog"
  ),
  addNavMenuSection({
    id: "customers",
    label: "nav.customer",
    items: [],
    requiresPermission: "__disable__",
  }),

  addNavMenuItem(
    {
      id: "products",
      label: "nav.product",
      routerLink: ["/catalog", "products"],
      requiresPermission: "__disable__",
    },
    "catalog"
  ),

  // addActionBarItem({
  //   id: "go-to-store",
  //   locationId: "product-detail",
  //   label: "Go to Store",
  //   buttonColor: "primary",
  //   icon: "store",
  //   onClick: async (event, context) => {
  //     const entity = context.entity$;
  //     context.entity$.pipe(take(1)).subscribe((e) => {
  //       const slug = e?.slug;
  //       var domain = window.location.hostname;
  //       var domainSegments = domain.split(".");
  //       var topLevelDomain = domainSegments.slice(-2).join(".");
  //       const baseUrl = window.location.port
  //         ? `http://${window.location.hostname}:8002`
  //         : `http://v2.${topLevelDomain}`;

  //       const url = `${baseUrl}/products/${slug}`;
  //       window.open(url, "_blank");
  //     });
  //   },
  // }),
];
